import React, { useEffect, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";

import clsx from "clsx";
import { Dispatch, bindActionCreators } from "redux";

import { Overlay, DefaultActionSection, BannerStatus } from "@plex/react-components";

import { INotification } from "infrastructure/notification";
import { Banner } from "ui/app";
import { useUserContext } from "ui/hooks";

import { TranslationsManagerFilter, TranslationsManagerGrid, TranslationsManagerActionBar } from "./components";
import { translationsManagerActions } from "./TranslationsManager.actions";
import styles from "./TranslationsManager.module.scss";
import { ITranslationsManagerState } from "./TranslationsManager.state";

interface ITranslationsManagerProps {
  state: ITranslationsManagerState;
  initialize: () => void;
  saveTermTranslations: () => void;
}

const TranslationsManager: React.FC<ITranslationsManagerProps & RouteComponentProps> = ({ state, initialize, saveTermTranslations }) => {
  const userContext = useUserContext();

  useEffect(() => {
    initialize();
  }, [initialize]);

  const saveTermTranslationsExecute = useCallback(() => {
    saveTermTranslations();
  }, [saveTermTranslations]);

  const roles = userContext.getRoleAccessData();
  const actionSectionDisplayed = useMemo(() => roles.PlexLocalizationManager || roles.Translator, [roles]);

  const bannerScroll = useCallback((message: INotification) => {
    return message.type === BannerStatus.error;
  }, []);

  return (
    <div className={clsx(styles.base, actionSectionDisplayed && styles.withActionSection)}>
      <Overlay show={state.isLoading} showSpinner />
      <Banner shouldScroll={bannerScroll} messages={state.notifications} />
      <TranslationsManagerFilter />
      <TranslationsManagerActionBar />
      <TranslationsManagerGrid />
      {actionSectionDisplayed && <DefaultActionSection onApply={saveTermTranslationsExecute} />}
    </div>
  );
};

export default connect(
  (state: { translationsManager: ITranslationsManagerState }) => {
    return {
      state: state.translationsManager
    };
  },
  (dispatch: Dispatch) => {
    return bindActionCreators(
      {
        saveTermTranslations: translationsManagerActions.saveTermTranslations,
        initialize: translationsManagerActions.initialize
      },
      dispatch
    );
  }
)(TranslationsManager);
